export default {
  pageHeroV1: {
    container: {
      height: '55vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'center',
      justifyContent: 'center'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      h1: {
        fontSize: ['1.75rem', '', '2.5rem'],
        marginBottom: '2rem',
        letterSpacing: '3px',
        textTransform: 'uppercase',
        color: 'white',
        borderColor: 'primary',

        padding: '1rem'
        // writingMode: 'vertical-rl',
      },
      h2: {
        marginBottom: '2rem'
      },
      button: {
        variant: 'buttons.multiLocation'
      }
    }
  }
}
